<template>
  <div>
    <b-breadcrumb
      class="mb-1"
      :items="breadcrumb"
    />

    <b-card>
      <b-card-title> Spider Job </b-card-title>
      <b-card-body v-if="isLoading">
        <div class="text-center">
          <b-spinner
            v-if="isLoading"
          />
        </div>
      </b-card-body>

      <b-card-body v-else>
        <validation-observer ref="rules">
          <b-row>
            <b-col cols="6">
              <validation-provider
                #default="{ errors }"
                rules="required"
              >
                <b-form-group
                  label="Nome"
                  label-for="name"
                >
                  <b-form-input
                    id="name"
                    v-model="spiderJob.name"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6">
              <validation-provider
                #default="{ errors }"
                rules="required"
              >
                <b-form-group
                  label="Prioridade"
                  description="Quanto maior o número, maior será a prioridade"
                  label-for="priority"
                >
                  <b-form-input
                    id="priority"
                    v-model="spiderJob.priority"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6">
              <b-form-group
                label="Ativo"
                label-for="business_hours_only"
              >
                <b-form-checkbox
                  v-model="spiderJob.active"
                  name="business_hours_only"
                  switch
                  inline
                >
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6">
              <b-form-group
                label="Enviar somente em horário comercial"
                label-for="business_hours_only"
              >
                <b-form-checkbox
                  v-model="spiderJob.business_hours_only"
                  name="business_hours_only"
                  switch
                  inline
                >
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6">
              <b-form-group
                label="Situação do usuário"
                label-for="user_situation"
              >
                <b-form-checkbox
                  v-model="spiderJob.situations.paying"
                  name="business_hours_only"
                  switch
                >
                  Pagante
                </b-form-checkbox>

                <b-form-checkbox
                  v-model="spiderJob.situations.free"
                  name="business_hours_only"
                  switch
                >
                  Gratuito
                </b-form-checkbox>

                <b-form-checkbox
                  v-model="spiderJob.situations.courtesy"
                  name="business_hours_only"
                  switch
                >
                  Cortesia
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Período -->
          <!-- Período -->
          <!-- Período -->
          <b-row>
            <b-col>
              <label>Período de Execução (Intervalo entre as execuções da rotina, o seja vai executar a cada: X dias, ou X horas, ou X minutos)</label>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="2">
              <validation-provider
                #default="{ errors }"
                rules="required"
              >
                <b-form-group
                  label=""
                  label-for="run_period_number"
                >
                  <b-form-input
                    id="run_period_number"
                    v-model="spiderJob.run_period_number"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="2">
              <validation-provider
                #default="{ errors }"
                rules="required"
              >
                <b-form-group
                  label=""
                  label-for="run_period_digit"
                >
                  <b-form-select
                    id="run_period_digit"
                    v-model="spiderJob.run_period_digit"
                    :options="run_period_options"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col>
              <small v-if="spiderJob.run_period_digit === 's'">1 Domingo, 2 Segunda, 3 Terça, 4 Quarta, 5 Quinta, 6 Sexta, 7 Sábado</small>
              <small v-if="spiderJob.run_period_digit === 'd'"><strong>Detalhamento: Todos os dias às <span v-if="spiderJob.run_period_number < 10">0</span>{{ spiderJob.run_period_number }}:00:00.</strong></small>
              <small v-if="spiderJob.run_period_digit === 'h'">Vai executar a cada {{ spiderJob.run_period_number }} horas, sempre no minuto 00. <strong>Detalhamento: {{ exampleRunPeriod }}</strong></small>
              <small v-if="spiderJob.run_period_digit === 'm'">Vai executar a cada {{ spiderJob.run_period_number }} minutos em todas as horas do dia. <strong>Detalhamento: {{ exampleRunPeriod }}</strong></small>
              <small v-if="spiderJob.run_period_digit === 's'"><br />Vai executar 1 vez no dia da semana selecionado, <strong>Detalhamento: {{ exampleRunPeriod }}</strong></small>
            </b-col>
          </b-row>

          <!-- Delay -->
          <!-- Delay -->
          <!-- Delay -->
          <b-row>
            <b-col>
              <label>Delay para o envio</label> (<small>Tempo a aguardar antes de enviar a mensagem(whats ou e-mail) a partir do momento que a rotina executa e obtém 1 ou mais resultados</small>)
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="2">
              <validation-provider
                #default="{ errors }"
                rules="required"
              >
                <b-form-group
                  label=""
                  label-for="delay_period_number"
                >
                  <b-form-input
                    id="delay_period_number"
                    v-model="spiderJob.delay_period_number"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="2">
              <validation-provider
                #default="{ errors }"
                rules="required"
              >
                <b-form-group
                  label=""
                  label-for="delay_period_digit"
                >
                  <b-form-select
                    id="delay_period_digit"
                    v-model="spiderJob.delay_period_digit"
                    :options="delay_period_options"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <!-- Requerimentos -->
          <!-- Requerimentos -->
          <!-- Requerimentos -->
          <div
            class="p-1"
            style="background-color: #efefef; border-radius: 10px"
          >
            <b-row>
              <b-col>
                Requerimentos
                <small>(O valor 'De' deve ser mais no passado que o 'Até')</small>
              </b-col>
            </b-row>

            <b-row
              v-for="requirement in spiderJob.requirements"
              :key="requirement.id"
              class="mb-2"
            >
              <b-col cols="3">
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group
                    label="Tag"
                    label-for="run_period_number"
                  >

                    <b-form-select
                      id="delay_period_digit"
                      v-model="requirement.tag"
                      :options="requirements_tags"
                      :disabled="isLoadingTags"
                    />

                    <b-spinner
                      v-if="isLoadingTags"
                      style="position: absolute; margin-left: -30px; margin-top: 12px;"
                      small
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col>
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group
                    label="Quantidade (=, <, >)"
                    label-for="requirement_quantity"
                  >
                    <b-form-input
                      id="delay_period_number"
                      v-model="requirement.quantity"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col
                cols="3"
                style="border: 1px solid #aaa; border-radius: 5px;"
              >
                <label>De:</label>

                <div class="d-flex">
                  <cleave
                    id="delay_period_from_number"
                    v-model="requirement.from_number"
                    class="form-control"
                    :raw="false"
                    :options="{
                      prefix: '',
                      numeral: true,
                    }"
                    :disabled="['now', 'today'].includes(requirement.from_digit)"
                  />

                  <b-form-select
                    id="delay_period_from_digit"
                    v-model="requirement.from_digit"
                    class="ml-1"
                    :options="requirement_period_options"
                    @change="handleChangeRequirementDigit(requirement)"
                  />
                </div>
              </b-col>

              <b-col
                cols="3"
                class="ml-1"
                style="border: 1px solid #aaa; border-radius: 5px;"
              >
                <label>Até:</label>

                <div class="d-flex">
                  <cleave
                    id="delay_period_to_number"
                    v-model="requirement.to_number"
                    class="form-control"
                    :raw="false"
                    :options="{
                      prefix: '',
                      numeral: true,
                    }"
                    :disabled="['now', 'today'].includes(requirement.to_digit)"
                  />

                  <b-form-select
                    id="delay_period_to_digit"
                    v-model="requirement.to_digit"
                    class="ml-1"
                    :options="requirement_period_options"
                    @change="handleChangeRequirementDigit(requirement)"
                  />
                </div>
              </b-col>

              <b-col cols="1">
                <b-button
                  class="mt-2"
                  @click="removeRequirement(requirement.id)"
                >
                  <feather-icon
                    icon="TrashIcon"
                    size="16"
                    class="align-middle"
                  />
                </b-button>
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col>
                <b-button
                  @click="addRequirement"
                >
                  Adicionar Requerimento
                </b-button>
              </b-col>
            </b-row>
          </div>

          <div class="mt-2">
            <span class="font-weight-bold">Quantidade</span>
            <div class="ml-2 mb-1">
              <p class="mb-0">
                =1 - A quantidade deve ser exatamente igual 1
              </p>
              <p class="mb-0">
                &lt;1 - A quantidade deve ser menor que 1
              </p>
              <p class="mb-0">
                &gt;1 - A quantidade deve ser maior que 1
              </p>
            </div>

            <span class="font-weight-bold">Explicações das Tags selecionadas</span>

            <div class="ml-2">
              <p
                v-for="tag in listAllTags"
                :key="`description-${tag}`"
                class="mb-2"
              >
                <span class="font-weight-bold">{{ tag.name }}</span><br />
                <span>{{ description_tags[tag.tag] ? description_tags[tag.tag] : '' }}</span>
              </p>
            </div>
          </div>

          <b-row class="mt-2">
            <b-col cols="10">
              <b-form-group
                label="Mensagem via WhatsApp"
                label-for="message_whats"
              >
                <b-form-checkbox
                  v-model="spiderJob.is_message_whats"
                  name="is_message_whats"
                  switch
                />

                <validation-provider
                  #default="{ errors }"
                  rules="required|min:10"
                >
                  <quill-editor
                    v-if="spiderJob.is_message_whats"
                    id="message_whats"
                    v-model="spiderJob.message_whats"
                    :class="{ 'disabled': isSubmiting }"
                    :disabled="isSubmiting"
                    :options="editorWhatsOption"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="10">

              <b-form-group
                label="Mensagem via E-mail"
                label-for="message_email"
              >
                <b-form-checkbox
                  v-model="spiderJob.is_message_email"
                  name="is_message_email"
                  switch
                />
              </b-form-group>

              <div
                v-if="spiderJob.is_message_email"
              >
                <validation-provider
                  #default="{ errors }"
                  rules="required|min:5"
                >
                  <b-form-group
                    label="Assunto"
                    label-for="subject_email"
                  >
                    <b-form-input
                      id="subject_email"
                      v-model="spiderJob.subject_email"
                    />
                  </b-form-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

                <validation-provider
                  #default="{ errors }"
                  rules="required|min:10"
                >
                  <b-form-group
                    label="Corpo"
                    label-for="message_email"
                  >
                    <quill-editor
                      id="message_email"
                      v-model="spiderJob.message_email"
                      :class="{ 'disabled': isSubmiting }"
                      :disabled="isSubmiting"
                      :options="editorOption"
                    />
                  </b-form-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>

            </b-col>
          </b-row>

          <div
            class="text-right"
          >
            <b-button
              :disabled="isSaving"
              class="mr-2"
              @click="back()"
            >
              Voltar
            </b-button>

            <b-button
              :disabled="isSaving"
              variant="gradient-primary"
              @click="saveJob()"
            >
              Salvar
              <b-spinner
                v-if="isSaving"
                small
              />
            </b-button>
          </div>
        </validation-observer>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BBreadcrumb,
  BSpinner,
  BButton,
  BCardTitle,
  BCardBody,
  BFormCheckbox,
} from 'bootstrap-vue'
import { maskDate } from '@/utils/masks'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import SpiderJobService from '@/services/spiderJobService'
import Cleave from 'vue-cleave-component'
import toast from '@/mixins/toast'
import multiSort from '@/mixins/multiSort'

// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'SpiderJobEdit',
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BBreadcrumb,
    BFormCheckbox,
    BSpinner,
    BButton,
    BCardTitle,
    BCardBody,
    quillEditor,
    ValidationObserver,
    ValidationProvider,
    Cleave,
  },
  mixins: [toast, multiSort],
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      breadcrumb: [
        {
          text: 'Dashboard',
          to: { name: 'cms-dashboard' },
        },
        {
          text: 'Ferramentas - Spider Jobs',
          to: { name: 'cms-tools-spider' },
        },
        {
          text: 'Adicionar',
          active: true,
        },
      ],
      run_period_options: [
        {
          value: 'd',
          text: 'Todos os dias na hora X',
        },
        {
          value: 'h',
          text: 'Horas',
        },
        {
          value: 'm',
          text: 'Minutos',
        },
        {
          value: 's',
          text: 'Dia da semana (executará as 08:00)',
        },
      ],
      delay_period_options: [
        {
          value: 'd',
          text: 'Dias',
        },
        {
          value: 'h',
          text: 'Horas',
        },
        {
          value: 'm',
          text: 'Minutos',
        },
      ],
      requirement_period_options: [
        {
          value: 'today',
          text: 'Hoje (00:00:00)',
        },
        {
          value: 'now',
          text: 'Agora (momento de execução da rotina)',
        },
        {
          value: 'd',
          text: 'Dias',
        },
        {
          value: 'h',
          text: 'Horas',
        },
        {
          value: 'm',
          text: 'Minutos',
        },
      ],
      editorOption: {
        syntax: false,
        placeholder: 'Mensagem',
        modules: {
          toolbar: [
            ['bold', 'italic'],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ['link'],
          ],
        },
      },
      editorWhatsOption: {
        syntax: false,
        placeholder: 'Mensagem',
        modules: {
          toolbar: [
            ['bold'],
          ],
        },
      },
      isSubmiting: false,
      isLoading: false,
      isLoadingTags: false,
      requirements_tags: [],
      description_tags: {
        changed_registration: 'A tag é criada sempre que um usuário altera seu registro.',
        changed_responsible: 'A tag é criada sempre que um usuário altera o responsável pelo cadastro.',
        message_without_quota: 'A tag é criada sempre que um usuário tenta enviar uma mensagem sem quota.',
        abandoned_cart: 'A tag é criada a cada 30 minutos, quando um usuário chega na tela de pagamento de assinatura mas não paga e não gera o boleto.',
        checkout_page: 'A tag é criada sempre que o usuário chega na tela de pagamento da assinatura.',
        accessed_plan_page: 'A tag pe criada sempre que o usuário acessa a página de planos',
        tried_access_phone: 'A tag é criada sempre que o usuário acessa o telefone de um associado',
        login_and_dont_search: 'A tag é criada a cada 30 minutos, se satisfizer as condições: Busca no intervalo de -35min -5min. Verifica todos os logins do usuário. Recebe a tag se tiver 2 logins seguidos sem nenhuma busca entre eles',
        message_only_view: 'A tag é criada a cada 30 minutos, se satisfizer as condições: Busca no intervalo de -35min -5min. Recebe a tag se o usuário viu a mensagem e não respondeu',
        email_only_open: 'A tag é criada a cada 30 minutos, se satisfizer as condições: Busca no intervalo de -35min -5min. Recebe a tag se o usuário abriu o e-mail e não clicou no link',
        search_and_dont_send_message: 'A tag é criada a cada 30 minutos, se satisfizer as condições: Busca no intervalo de -35min -5min. Soma as buscas e as mensagens enviadas do usuário. Recebe a tag se tiver mais de 1 busca e 0 mensagens enviadas',
        open_profile_and_dont_send_message: 'A tag é criada a cada 30 minutos, se satisfizer as condições: Busca no intervalo de -35min -5min. Soma os perfis abertos e as mensagens enviadas do usuário. Recebe a tag se tiver mais de 10 perfis abertos e 0 mensagens enviadas',
        update_profile_data: 'A tag é criada a cada 30 minutos, se satisfizer as condições: Busca usuários que alteram seu perfil/cadastro no dia. Recebe a tag se o usuário estiver a mais de 30 dias sem alterar o perfil/cadastro',
        send_message_after_long_time: 'A tag é criada a cada 30 minutos, se satisfizer as condições: Busca usuários que enviaram mensagem nos últimos 30 minutos. Recebe a tag se o usuário estiver a mais de 30 dias sem enviar mensagens',
        read_message_after_long_time: 'A tag é criada a cada 30 minutos, se satisfizer as condições: Busca usuários que leram mensagem nos últimos 30 minutos. Recebe a tag se o usuário estiver a mais de 30 dias sem ler mensagens',
        long_time_without_login: 'A tag é criada uma vez por dia, às 01:00:00, se satisfizer as condições: Recebe a tag os usuários que não logaram nos últimos 30 dias',
        long_time_without_message: 'A tag é criada uma vez por dia, às 01:00:00, se satisfizer as condições: Recebe a tag os usuários que não enviaram mensagem nos últimos 30 dias',
        long_time_without_open_email: 'A tag é criada uma vez por dia, às 01:00:00, se satisfizer as condições: Recebe a tag os usuários que não abriram nenhum e-mail nos últimos 30 dias, mas somente os usuários que receberam mais de 5 e-mails no último mês.',
        long_time_without_plan: 'A tag é criada uma vez por dia, às 01:00:00, se satisfizer as condições: Recebe a tag os usuários que estão a 45 dias sem pagar por um plano e com plano vencido',
        gold_send_more_messages_than_view_phone: 'A tag é criada uma vez por dia, às 01:00:00, se satisfizer as condições: Recebe a tag os usuários que pagaram o último plano gold a 15 dias, e neste período enviaram mais mensagens do que acessaram telefones',
        email_after_long_time: 'A tag é criada a cada 30 minutos, se satisfizer as condições: Recebe a tag o usuário enviou um novo e-mail para o hafidme após 30 dias ou mais sem enviar nenhum e-mail',
        chat_after_long_time: 'A tag é criada a cada 30 minutos, se satisfizer as condições: Recebe a tag o usuário abriu um novo chat no site após 30 dias ou mais sem abrir nenhum chat',
        sent_messages_and_did_not_hit_other_tags: 'A tag é criada a cada 30 minutos, se satisfizer as condições: Recebe a tag o usuário que enviou mais de 2 mensagens nos últimos 30 dias e não caiu em nenhuma outra tag do spider no mesmo período',
      },
      spiderJob: {
        id: null,
        name: '',
        business_hours_only: false,
        situations: {
          paying: true,
          free: true,
          courtesy: true,
          is_message_whats: false,
          is_message_email: false,
        },
        requirements: [
          {
            id: 0,
            quantity: 1,
            from_number: -1,
            from_digit: 'd',
            to_number: 0,
            to_digit: 'now',
          },
        ],
        is_message_whats: false,
        is_message_email: false,
        run_period_number: '15',
        run_period_digit: 'm',
        delay_period_number: '0',
        delay_period_digit: 'm',
        message_whats: '',
        subject_email: '',
        message_email: '',
        last_run_at: null,
      },
      isSaving: false,
      maskDate,
      fields: [
        'id',
        'subject',
        'body',
        'to',
        'body',
        'status',
        'discount',
        'discount_type',
        'discount_expires_at',
      ],
    }
  },
  computed: {
    listAllTags() {
      const s = new Set(this.spiderJob.requirements.map(m => ({
        tag: m.tag ?? '',
        name: this.requirements_tags.find(f => f.value === m.tag ?? '')?.text,
      })))

      return [...s].sort(this.fieldSorter(['name']))
    },

    exampleRunPeriod() {
      if (this.spiderJob.run_period_digit === 'h') {
        const text = []
        const add = parseInt(this.spiderJob.run_period_number, 10)
        for (let i = 0; i < 24; i += add) {
          text.push(`${i < 10 ? '0' : ''}${i}:00:00`)
        }

        return text.join(', ')
      }

      if (this.spiderJob.run_period_digit === 'm') {
        const text = []
        const add = parseInt(this.spiderJob.run_period_number, 10)
        for (let i = 0; i < 60; i += add) {
          text.push(`HH:${i < 10 ? '0' : ''}${i}:00`)
        }

        return text.join(', ')
      }

      if (this.spiderJob.run_period_digit === 's') {
        if (this.spiderJob.run_period_number === '1') {
          return 'Domingo às 08:00:00'
        }
      }

      return ''
    },
  },
  watch: {
  },
  async created() {
    if (this.$route.params.id && this.$route.params.id > 0) {
      await this.getJob(this.$route.params.id)
    }
    await this.listTags()
  },
  methods: {
    listTags() {
      this.isLoadingTags = true
      SpiderJobService.listTags().then(response => {
        this.requirements_tags = response.data.data.tags
        this.requirements_tags.sort(this.fieldSorter(['text']))
      }).finally(() => {
        this.isLoadingTags = false
      })
    },

    removeRequirement(id) {
      this.spiderJob.requirements = this.spiderJob.requirements.filter(f => f.id !== id)
    },

    addRequirement() {
      const nextId = this.spiderJob.requirements.map(m => m.id).sort().reverse()[0] + 1
      this.spiderJob.requirements.push({
        id: nextId,
        quantity: 0,
        from: '',
        from_number: 0,
        from_digit: '',
        to: '',
        to_number: 0,
        to_digit: '',
      })
    },

    handleChangeRequirementDigit(requirement) {
      if (['now', 'today'].includes(requirement.to_digit)) {
        // eslint-disable-next-line no-param-reassign
        requirement.to_number = ''
      }

      if (['now', 'today'].includes(requirement.from_digit)) {
        // eslint-disable-next-line no-param-reassign
        requirement.from_number = ''
      }
    },

    async getJob(id) {
      this.isLoading = true
      return SpiderJobService.getJob(id).then(response => {
        this.spiderJob = {
          ...response.data.data.job,
          is_message_whats: !!(response.data.data.job.message_whats && response.data.data.job.message_whats.length > 0),
          is_message_email: !!(response.data.data.job.message_email && response.data.data.job.message_email.length > 0),
        }
        this.spiderJob.situations = {
          paying: this.spiderJob.situations.includes('paying'),
          free: this.spiderJob.situations.includes('free'),
          courtesy: this.spiderJob.situations.includes('courtesy'),
        }
      }).finally(() => {
        this.isLoading = false
      })
    },

    back() {
      this.$router.push({ name: 'cms-tools-spider', params: { } })
    },

    async saveJob() {
      const validated = await this.$refs.rules.validate()
      if (!validated) {
        return
      }

      if (!this.spiderJob.is_message_whats) {
        this.spiderJob.message_whats = ''
      }
      if (!this.spiderJob.is_message_email) {
        this.spiderJob.message_email = ''
      }

      if (this.spiderJob.message_whats === '' && this.spiderJob.message_email === '') {
        this.toastDanger('Escreva ao menos uma mensagem (WhatsApp ou E-mail)')
        return
      }

      this.isSaving = true

      const data = this.spiderJob
      data.situations = Object.entries(this.spiderJob.situations).filter(f => f[1]).map(m => m[0])

      try {
        await SpiderJobService.saveJob(data)
        await this.$router.push({ name: 'cms-tools-spider' })
      } catch (error) {
        this.$swal({
          title: 'Erro ao salvar',
          text: error.response ? Object.values(error.response.data.errors) : error.message,
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      } finally {
        this.isSaving = false
      }
    },
  },
}
</script>

<style>
 .ql-editor {
   min-height: 150px;
 }
</style>
